module.exports = __webpack_public_path__ + "img/trunk_10x2_z18.e992dea6.svg";